import React from 'react';
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { BiAddToQueue } from 'react-icons/bi';
import _ from 'underscore';

import { SkeletonTable, SkeletonPageFooter } from 'ui/components/skeleton';
import useTable from 'ui/components/table';

import tableConfig from './table.config';
import FormInput from './form';

const initialState = {
  privilege: null,
  isShow: false,
};

const SettingUsergroupScreen = () => {
  const Session = useSelector((state) => state.Auth?.session);
  const UsergroupTable = useTable('usergroup', tableConfig);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );

  const [{ isShow, privilege }, setState] = React.useState(initialState);

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.usergroup',
    });
    setState((prevState) => ({ ...prevState, privilege: x }));
  };

  React.useEffect(() => {
    $getPriviledge();
  }, [Session]);

  return (
    <div className="sub-page">
      <div className="sub-page-navigation">
        <UsergroupTable.Tools>
          {(!Session?.privileges || privilege?.action === 'manage') && (
            <button
              onClick={() =>
                setState((prevState) => ({ ...prevState, isShow: true }))
              }
              className="btn btn-primary py-1 ms-1"
            >
              <BiAddToQueue color="white" size="14" />
              <span className="d-none d-md-block ms-2">
                Tambah Usergroup Baru
              </span>
            </button>
          )}
        </UsergroupTable.Tools>
      </div>
      <div className="sub-page-body">
        {StateLoading ? (
          <SkeletonTable headerCount={6} bodyCount={10} />
        ) : (
          <UsergroupTable.Render />
        )}
      </div>
      <div className="sub-page-footer">
        {StateLoading ? <SkeletonPageFooter /> : <UsergroupTable.Pagination />}
      </div>

      <Modal
        show={isShow}
        onHide={() =>
          setState((prevState) => ({ ...prevState, isShow: false }))
        }
        backdrop="static"
        centered
        scrollable
        size="lg"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Tambah Usergroup</Modal.Title>
        </Modal.Header>
        <FormInput
          onClose={() => {
            setState((prevState) => ({ ...prevState, isShow: false }));
          }}
        />
      </Modal>
    </div>
  );
};

export default SettingUsergroupScreen;
